import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const PageNotFound = () => {
  return (
    <StyledPageNotFound>
      <div className="content-container">
        <motion.div 
          className="error-code"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          404
        </motion.div>
        <motion.div 
          className="message"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <h1>Page not found</h1>
          <p>The page you're looking for doesn't exist or has been moved.</p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <Link to="/" className="home-button">
            Back to home
          </Link>
        </motion.div>
      </div>
      <div className="gradient-bg"></div>
    </StyledPageNotFound>
  );
};

const StyledPageNotFound = styled.div`
  height: calc(100vh - 150px);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  
  .content-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 2rem;
    max-width: 600px;
    z-index: 1;
  }
  
  .error-code {
    font-size: 10rem;
    font-weight: 800;
    line-height: 1;
    background: linear-gradient(135deg, #4a5bef 0%, #8F3CDA 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    margin-bottom: 1rem;
    text-shadow: 0 10px 30px rgba(var(--vibrant-rgb), 0.2);
  }
  
  .message {
    margin-bottom: 2.5rem;
    
    h1 {
      font-size: 2.5rem;
      color: var(--primary-text);
      margin-bottom: 1rem;
      font-weight: 600;
    }
    
    p {
      font-size: 1.1rem;
      color: var(--secondary-text, rgba(var(--primary-text-rgb), 0.7));
      max-width: 500px;
      margin: 0 auto;
    }
  }
  
  .home-button {
    display: inline-block;
    padding: 0.8rem 1.8rem;
    font-size: 1rem;
    font-weight: 500;
    color: white;
    background: linear-gradient(135deg, #4a5bef 0%, #8F3CDA 100%);
    border-radius: 30px;
    text-decoration: none;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(var(--vibrant-rgb), 0.3);
    
    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 8px 25px rgba(var(--vibrant-rgb), 0.4);
    }
  }
  
  .gradient-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    background: radial-gradient(
      circle at 30% 50%, 
      rgba(var(--vibrant-rgb), 0.05) 0%, 
      rgba(var(--vibrant-rgb), 0) 50%
    );
  }
  
  @media only screen and (max-width: 768px) {
    .error-code {
      font-size: 8rem;
    }
    
    .message h1 {
      font-size: 2rem;
    }
    
    .message p {
      font-size: 1rem;
    }
  }
  
  @media only screen and (max-width: 480px) {
    .error-code {
      font-size: 6rem;
    }
    
    .message h1 {
      font-size: 1.6rem;
    }
  }
`;

export default PageNotFound;
